import React, { useEffect, useState } from 'react';
import '../assets/styles/client.css';
import addmember from '../assets/images/addclent.svg';
import trial_user from '../assets/images/trial_user.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft, faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import Addmembers from './addmembers';
import Faeditimg from '../assets/Francias/faedit.svg';
import pdfimg from '../assets/Francias/franciaspdf.svg';
import closebtn from '../assets/Francias/closebtn.svg';
import ClientAssign from './Assign/clientAssign';
import { toast } from 'react-toastify';
import config from '../config.js';
import MakeTrial from '../components/vendor/maketrail-popup.js';
import { AnimatePresence } from "framer-motion";

const Client = ({ pageName }) => {
    const [clientData, setClientData] = useState([]);
    const [show, setShow] = useState(false);
    const [isaddmember, setIsaddmember] = useState(false);
    const [isclientassign, setIsclientassign] = useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const handleClosePopup = () => { setIsPopupOpen(false); };
    const closeclientassign = () => { setIsclientassign(false); }
    const [selectedClient, setSelectedClient] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(24);
    const closeaddmember = () => {
        setIsaddmember(false);
        fetchClientData();
    }
    const label = [
        { id: 1, label: "Facial attendance" },
        { id: 2, label: "Gender classification" },
        { id: 3, label: "Unknown tracking" },
        { id: 4, label: "People In / Out" },
        { id: 5, label: "Crowd detection" },
        { id: 6, label: "Trespass detection" },
        { id: 7, label: "Tripwire detection" },
        { id: 8, label: "Vehicle In / Out" },
        { id: 9, label: "ANPR" },
        { id: 10, label: "PPE detection" },
        { id: 11, label: "Camara tempering" }
    ];
    const fetchClientData = async () => {
        try {
            const response = await fetch(`${config.apiBaseUrl}/admin/getclient`);
            if (!response.ok) {
                throw new Error("Failed to fetch client data");
            }
            const responseData = await response.json();
            setClientData(responseData.data);
            setFilteredData(responseData.data);
        } catch (err) {
            console.error("Error fetching client data:", err);
            toast.error(err.message);
        }
    };
    useEffect(() => {
        fetchClientData();
    }, []);

    const handleShow = () => setShow(true);

    useEffect(() => {
        const lowerCaseQuery = searchQuery.toLowerCase();
        const filtered = clientData.filter(client =>
            client.name.toLowerCase().includes(lowerCaseQuery) ||
            client.email.toLowerCase().includes(lowerCaseQuery)
        );
        setFilteredData(filtered);
    }, [searchQuery, clientData]);

    const handleOpenPopup = async (id) => {
        try {
            const response = await fetch(`${config.apiBaseUrl}/admin/getClientById/${id}`);
            if (!response.ok) throw new Error("Failed to fetch client details");

            const clientDetails = await response.json();
            setSelectedClient(clientDetails.data);
            setIsPopupOpen(true);
        } catch (err) {
            toast.error(err.message);
        }
    };

    // Logic to handle pagination
    const indexOfLastClient = currentPage * itemsPerPage;
    const indexOfFirstClient = indexOfLastClient - itemsPerPage;
    const currentClients = filteredData.slice(indexOfFirstClient, indexOfLastClient);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const closeTrialPage = () => {
        setShow(false);
    };
    
    return (
        isaddmember === true ? (
            <div className=''>
                <Addmembers closePopup={closeaddmember} pageName={pageName} />
            </div>
        )
            : (
                isclientassign === true ? (
                    <div className=''>
                        <ClientAssign closePopup={closeclientassign} clientData={selectedClient} pageName={pageName} />
                    </div>
                )
                    : (
                        <div className='camera-cm'>
                            <div className='row mb-2'>
                                <div className='col-12 col-md-6 col-lg-5 search-iconst'>
                                    <div className="search-bar">
                                        <FontAwesomeIcon className="search-icon" icon={faMagnifyingGlass} />
                                        <input
                                            type="search"
                                            placeholder="Search"
                                            aria-label="Search"
                                            className='search-bar-input'
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="col-lg-7 col-md-6 col-12 align-items-end button-cm pb-0">
                                    <div className='d-flex justify-content-end gap-2'>
                                        <button type="submit" title='Make trial' className="btn btn-secondary d-flex trial-cam-cm text-doted" onClick={handleShow} >
                                            <img src={trial_user} alt='trial_user' className='button-st-cm' /> <span className='hide-856'>Make trial</span>
                                        </button>

                                        <AnimatePresence>
                                            {show && <MakeTrial onClose={closeTrialPage} />}
                                        </AnimatePresence>

                                        <button type="submit" title='Add camera' className="btn btn-secondary d-flex add-cam-cm text-doted" onClick={() => { setIsaddmember(true); }}>
                                            <img src={addmember} alt='addcam' className='button-st-cm' /> <span className='hide-856'>Add members</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="overall-container">
                                <div className="table-responsive">
                                    <table className="table table-bordered">
                                        <thead className="table-th">
                                            <tr>
                                                <th>S.no</th>
                                                <th>Name</th>
                                                <th>Type</th>
                                                <th>Email</th>
                                                <th>Phone</th>
                                                <th>Join date</th>
                                                <th>Details</th>
                                            </tr>
                                        </thead>
                                        <tbody className="tbody-responsive">
                                            {currentClients.length > 0 ? (
                                                currentClients.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{item.name}</td>
                                                        <td>{item.client_type}</td>
                                                        <td>{item.email}</td>
                                                        <td>{item.phone_number}</td>
                                                        <td>{new Date(item.created_at).toLocaleDateString()}</td>
                                                        <td onClick={() => handleOpenPopup(item.id)}>
                                                            <span className="clientviewpopup">View</span>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="7">No matching data found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                            </div>
                            <div className="pagination mt-2 d-flex justify-content-end">
                                <button className='leftcherve' onClick={() => paginate(currentPage - 1)} disabled={currentPage === 1}><FontAwesomeIcon icon={faChevronLeft} /></button>
                                {Array.from({ length: Math.ceil(filteredData.length / itemsPerPage) }, (_, index) => (
                                    <button key={index} onClick={() => paginate(index + 1)} className={`paginationcnt ${currentPage === index + 1 ? 'active' : ''}`}>
                                        {index + 1}
                                    </button>
                                ))}
                                <button className='rightcherve' onClick={() => paginate(currentPage + 1)} disabled={currentPage === Math.ceil(filteredData.length / itemsPerPage)}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                            {isPopupOpen && (
                                <div className="popup-overlay">
                                    <div className="popup-content">
                                        <p onClick={handleClosePopup} className='text-end mb-0 mt-2'><img src={closebtn} className='closebtn' alt="alt" /></p>
                                        <div className='mt-2'>
                                            <div className="popup-row"><strong>Client type</strong><span>: {selectedClient.client_type}</span></div>
                                            <div className="popup-row"><strong>Name:</strong><span>: {selectedClient.name}</span></div>
                                            <div className="popup-row"><strong>Phone no</strong><span>: {selectedClient.phone_number}</span></div>
                                            <div className="popup-row"><strong>Email</strong><span>: {selectedClient.email}</span></div>
                                            <div className="popup-row"><strong>Location</strong><span>: {selectedClient.country},{selectedClient.state}</span></div>
                                            <div className="popup-row"><strong>Post code</strong><span>: {selectedClient.city}-{selectedClient.pincode}</span></div>
                                            <div className="popup-row">
                                                <strong>No of cameras</strong>
                                                <span>:{" "}
                                                    {selectedClient.tool_camera
                                                        ? Object.values(selectedClient.tool_camera).reduce((sum, value) => sum + value, 0)
                                                        : 0}
                                                </span>
                                            </div>

                                            <div className='popup-row'>
                                                <strong>No of tools</strong>:
                                                <div className='row col-12 clentrows'>
                                                    {selectedClient.tool_camera && Object.entries(selectedClient.tool_camera).map(([key, value]) => {
                                                        const labelName = label.find(item => item.id === parseInt(key))?.label || `ID ${key}`;
                                                        return (
                                                            <div key={key} className='col-12 col-lg-5'>
                                                                {labelName}: {value}
                                                            </div>
                                                        );
                                                    })}
                                                </div>

                                            </div>

                                            <div className="popup-row"><strong>Date of purchase</strong><span>: {selectedClient.purchase_date ? new Date(selectedClient.purchase_date).toLocaleDateString("en-US") : null}</span></div>
                                            <div className="popup-row"><strong>Date of expiry</strong><span>: {selectedClient.expiry_date ? new Date(selectedClient.expiry_date).toLocaleDateString("en-US") : null}</span></div>
                                            <div className="popup-row"> <strong>Documents </strong><span>: <a href={selectedClient.doc_proof} target="_blank" rel="noopener noreferrer">
                                                <img src={pdfimg} alt="Document" />
                                            </a></span></div>
                                            <div className="d-flex justify-content-end align-items-center mt-2 gap-2">
                                                <button type="button" className="edit-savebtn"> <img src={Faeditimg} alt="Faeditimg" /> </button>
                                                <button type="button" className="Upgrade-savebtn" onClick={() => { setIsclientassign(true); }}>Upgrade</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
            )
    );
};

export default Client;
